/**
 * 第三幕策略定义
 *
 * 基础策略（每周可选）+ 特殊策略（全局限用1次）
 */
import type { StrategyId } from '../types/cards';

export interface StrategyDefinition {
  id: StrategyId;
  name: string;
  emoji: string;
  description: string;
  energyCost: number;
  isSpecial: boolean;
}

/** 基础策略 — 每周都可以选 */
export const BASE_STRATEGIES: StrategyDefinition[] = [
  {
    id: '全力维系',
    name: '全力维系',
    emoji: '💪',
    description: '投入大量精力维护关系，高承诺回报但精力消耗巨大',
    energyCost: 30,
    isSpecial: false,
  },
  {
    id: '理性沟通',
    name: '理性沟通',
    emoji: '🗣️',
    description: '冷静理性地沟通问题，平衡的选择',
    energyCost: 15,
    isSpecial: false,
  },
  {
    id: '暂时退让',
    name: '暂时退让',
    emoji: '🤝',
    description: '暂时退一步，保存精力但承诺可能下降',
    energyCost: 5,
    isSpecial: false,
  },
  {
    id: '冷处理',
    name: '冷处理',
    emoji: '❄️',
    description: '不主动处理，恢复精力但关系可能恶化',
    energyCost: -15,
    isSpecial: false,
  },
];

/** 特殊策略 — 全局限用1次 */
export const SPECIAL_STRATEGIES: StrategyDefinition[] = [
  {
    id: '惊喜破局',
    name: '惊喜破局',
    emoji: '🎁',
    description: '用一个精心准备的惊喜打破僵局，高风险高回报',
    energyCost: 25,
    isSpecial: true,
  },
  {
    id: '朋友助攻',
    name: '朋友助攻',
    emoji: '👥',
    description: '请朋友帮忙调解，适合社交类考验',
    energyCost: 10,
    isSpecial: true,
  },
  {
    id: '深度坦白',
    name: '深度坦白',
    emoji: '💎',
    description: '完全坦诚地表达内心想法，可能化解信任危机也可能适得其反',
    energyCost: 20,
    isSpecial: true,
  },
  {
    id: '暂时放手',
    name: '暂时放手',
    emoji: '🕊️',
    description: '给彼此一些空间和时间，适合双方都疲惫的时候',
    energyCost: 0,
    isSpecial: true,
  },
];

/** 所有策略 */
export const ALL_STRATEGIES: StrategyDefinition[] = [...BASE_STRATEGIES, ...SPECIAL_STRATEGIES];
